import '../App.css';
import { Link } from 'react-router-dom';
import Layout from "../components/Layout";

const GAMEMODES = [
  { slug: "addition", label: "Addition", glyph: "+", variant: "op-add" },
  { slug: "subtraction", label: "Subtraction", glyph: "−", variant: "op-sub" },
  { slug: "multiplication", label: "Multiplication", glyph: "×", variant: "op-mul" },
  { slug: "division", label: "Division", glyph: "÷", variant: "op-div" },
];

function Play() {
  return (
    <Layout>
      <h1 className="section-title">Pick Your Vine</h1>
      <p className="tagline">Sixty seconds on the clock. How many bananas can you bag?</p>

      <div className="op-grid">
        {GAMEMODES.map(({ slug, label, glyph, variant }) => (
          <Link key={slug} className={`op-card ${variant}`} to={`/play/regular/${slug}`}>
            <span className="op-glyph">{glyph}</span>
            <span className="op-label">{label}</span>
          </Link>
        ))}
      </div>

      <div className="leaf-divider">🌿 🐒 🌿</div>

      <Link className="btn btn-leaf" to="/">Back to the Treehouse</Link>
    </Layout>
  );
}

export default Play;
